import { render, staticRenderFns } from "./reason-editor.pug?vue&type=template&id=2ddd79a2&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./reason-editor.scss?vue&type=style&index=0&id=2ddd79a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd79a2",
  null
  
)

export default component.exports